import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

function SlotsStickyBar({ currency, effectivePrice, regularPrice = 0, memberNote = null, pickCount, sessionsN, minPicks, mode, blockedCount = 0, canContinue, onContinue }) {
  return (
    <Box
      sx={{
        position: "fixed",
        // Clears BottomNav, which is fixed at bottom 0 below md on non-checkout routes.
        bottom: { xs: "3.5rem", md: 0 },
        left: 0,
        right: 0,
        py: 2,
        px: 2,
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
        zIndex: 1000
      }}
    >
      <Box sx={{ maxWidth: "60rem", mx: "auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
        <Box>
          <Typography variant="subtitle2" fontWeight={700}>
            {regularPrice > effectivePrice && (
              <Box component="span" sx={{ mr: 0.75, fontWeight: 400, textDecoration: "line-through" }}>
                {currency} {regularPrice.toFixed(2)}
              </Box>
            )}
            {currency} {effectivePrice.toFixed(2)}
          </Typography>
          {blockedCount > 0 ? (
            <Typography variant="caption" color="error.main">
              {blockedCount === 1 ? "1 week unavailable" : `${blockedCount} weeks unavailable`} — open it to pick another time
            </Typography>
          ) : (
            <Typography variant="caption" color="textSecondary">
              {pickCount} of {sessionsN} sessions
            </Typography>
          )}
          {/* Where the picks must stay for the member price — it moves as they do. */}
          {memberNote && (
            <Typography variant="caption" sx={{ display: "block", color: memberNote.warning ? "warning.dark" : "primary.main", fontWeight: 600 }}>
              {memberNote.text}
            </Typography>
          )}
        </Box>
        <Button
          variant="contained"
          disabled={!canContinue}
          onClick={onContinue}
          sx={{ textTransform: "none", color: "common.white", minWidth: "11rem" }}
        >
          {/* An unopened hole outranks the count: a partial pack can be paid
              for with picks missing, but never without the client having looked
              at the week that could not be booked. */}
          {blockedCount > 0
            ? blockedCount === 1
              ? "Check 1 unavailable week"
              : `Check ${blockedCount} unavailable weeks`
            : pickCount < minPicks
              ? mode === "all"
                ? `Pick ${sessionsN - pickCount} more`
                : "Pick at least 1 session"
              : "Continue to payment"}
        </Button>
      </Box>
    </Box>
  );
}

export default SlotsStickyBar;
